import { render, staticRenderFns } from "./Djs.vue?vue&type=template&id=e7bfb616&scoped=true&"
import script from "./Djs.vue?vue&type=script&lang=js&"
export * from "./Djs.vue?vue&type=script&lang=js&"
import style0 from "./Djs.vue?vue&type=style&index=0&id=e7bfb616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bfb616",
  null
  
)

export default component.exports